<template>
  <div class="widget-home-container">
    <div v-if="isLoadingAvailableAgents" class="widget-home-loading">
      <img :src="loadingGif" alt="Loading Home Tab" class="widget-home-loading-gif"/>
    </div>
    <div v-else class="widget-loaded-content-wrapper">
      <div class="header">
        <img v-if="avatarUrl" :src="avatarUrl" class="widget-icon" alt="widget-icon"/>
        <div>
          <div class="widget-title">{{ title }}</div>
          <div class="widget-tagline">{{ tagline }}</div>
        </div>
      </div>
      <send-us-message
        v-bind="chatTabProps"
        :isOnline="isOnline"
      />
      <articles-listing key="articles-listing" :pinnedArticles="kbDetails.pinnedArticles" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SendUsMessage from '../components/SendUsMessage.vue';
import ArticlesListing from '../components/ArticlesListing.vue';
import availabilityMixin from 'widget/mixins/availability';
import configMixin from '../mixins/configMixin';
import loadingGif from '../assets/images/loading-articles.gif';

export default {
  name: "WidgetHome",
  components: {
    SendUsMessage,
    ArticlesListing
  },
  mixins: [availabilityMixin, configMixin],
  props: {
    chatTabProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loadingGif,
    }
  },
  computed: {
    ...mapGetters({
      kbDetails: 'kbDetails/getKbDetails',
      webChannelConfig: 'appConfig/getWebChannelConfig',
      hiverConfig: 'hiverConfig/getHiverConfig',
      availableAgents: 'agent/availableAgents',
      isLoadingAvailableAgents: 'agent/getIsLoading',
    }),
    title() {
      return this.webChannelConfig.welcomeTitle;
    },
    tagline() {
      return this.webChannelConfig.welcomeTagline;
    },
    avatarUrl() {
      return this.webChannelConfig.avatarUrl;
    },
    isOnline() {
      const { workingHoursEnabled } = this.channelConfig;
      const anyAgentOnline = this.availableAgents.length > 0;

      if (workingHoursEnabled) {
        return (anyAgentOnline && this.isInBetweenTheWorkingHours) || this.hasAConnectedAgentBot;
      }
      return anyAgentOnline || this.hasAConnectedAgentBot;
    },
  }
};
</script>
<style>
@import "~widget/assets/scss/_widgetHome.scss";
</style>
